import Forms from '@piconetworks/module-forms'

// import Forms from 'common/picore/src/packages/Modules/Forms/index'
import createDuck from '../baseDuck'

export default Forms({
    createDuck,
})
